


export const userNotRolesGuid = '97c2b686-2fad-ee11-b01c-08606e00ebaa';

export const defaultEmptyGuid = '00000000-0000-0000-0000-000000000000';
export const defaultRadioGroupId = '08D82832-4E2E-EC11-8BAA-000C2921BB2F';
export const defaultRadioDasteId = 'A684CADF-4E2E-EC11-8BAA-000C2921BB2F';

export const groupRadioIdMenuType = 'D8960DE6-8F70-ED11-AC26-14D64D18FB57';//گروه نوع منو 

export const groupRadioIdFeedbackState = '9F79C540-A660-EC11-8BAB-000C2921BB2F';//گروه وضعیت بازخورد 
export const groupRadioIdFeedbackNatije = '21B9E082-9D68-EC11-8BAB-000C2921BB2F';//گروه نتیجه بررسی بازخورد 
export const groupRadioIdFeedbackOlaviat = 'AC74A1D3-6468-EC11-8BAB-000C2921BB2F';//گروه اولویت بازخورد
export const groupRadioIdFeedbackType = '2BA23EB6-D366-EC11-8BAB-000C2921BB2F';//گروه نوع بازخورد

export const RadioIdFeedbackStateOpen = 'A7EBE651-A660-EC11-8BAB-000C2921BB2F';// وضعیت فیدبک باز
export const RadioIdFeedbackStateClose = '92EDE260-A660-EC11-8BAB-000C2921BB2F';// وضعیت فیدبک بسته شده

export const RadioIdFeedbackOlaviatAdi = 'D5E486E1-6468-EC11-8BAB-000C2921BB2F';// اولویت فیدبک عادی

export const TypeChart = 1;
export const TypeMenu = 2;
export const TypeFunctional = 3;
export const TypeDataSource = 4;
export const TypePackage = 5;
export const TypeRadio = 6;
export const TypePage = 7;
export const TypeForm = 8;

export const ChartView = 1;
export const ChartAdd = 2;
export const ChartEdit = 3;
export const ChartDelete = 4;
export const ChartSecurity = 24;

export const MenuView = 5;
export const MenuAdd = 6;
export const MenuEdit = 7;
export const MenuDelete = 8;
export const MenuSecurity = 25;

export const DataSourceView = 9;
export const DataSourceAdd = 10;
export const DataSourceEdit = 11;
export const DataSourceDelete = 12;
export const DataSourceSecurity = 26;

export const FormView = 27;
export const FormAdd = 28;
export const FormEdit = 29;
export const FormDelete = 30;
export const FormSecurity = 31;

export const RadioView = 13;
export const RadioAdd = 14;
export const RadioEdit = 15;
export const RadioDelete = 16;

export const AdminAccessOnCharts = 17;
export const AdminAccessOnMenus = 18;
export const AdminAccessOnDataSources = 19;
export const AdminAccessOnForms = 32;

export const DashboardAddDeleteArragneCharts = 20;
export const ManageAllUsersAndRoles = 21;
export const ViewManageMainMenu = 22;
export const ArrangeMenus = 23;

